<template>
    <div>
        <transition v-for="popup in popups" :key="popup._id">
            <component :is="skinComponent" :popup="popup"></component>
        </transition>
    </div>
</template>

<script>
import api from "@/api";

export default {
    props: {
        skin: { type: String, default: "basic" },
        code: { type: String }
    },
    data(){
        return {
            popups: []
        }
    },
	mounted() {
		this.init();
	},
	methods: {
		async init() {
            var { popups } = await api.v1.common.popups.gets({
                headers: {
                    code: this.code
                }
            });
            this.popups = popups;
		},
	},
    computed: {
        skinComponent(){
            console.log(this.skin)
            return () => import(`./skin/${this.$props.skin}/view.vue`);
        }
    }
}
</script>
<style scoped>
.floating-layout {
    position: fixed;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    overflow: visible;
    z-index: 999;
}
</style>